import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'

export const Value = styled(Grid, {
  name: 'Value',
  slot: 'Root',
  skipSx: true,
})`
  font-family: 'Source Sans Pro Semibold';
`
